import styles from './NavIcon.module.css'
import navOpenIcon from '../../assets/icons/nav-open.svg'
const NavIcon = (props) => {
    return <div onClick={props.onClick} className={styles.iconContainer}>
        <img className={styles.icon} src={navOpenIcon} alt='Open Navigation Icon' />
    </div>
}

export default NavIcon